import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PurchaseMaterialReceiptIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ActualDateChange, PlannedDateToken, ActualDateToken } from '../../../shared/misc-classes';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../../shared/dataservice.service';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { GenService } from '../../../shared/gen-ser.service';

@Component({
  selector: 'purchase-material-receipt',
  templateUrl: './purchase-material-receipt.component.html',
  styleUrls: ['./purchase-material-receipt.component.css']
})
export class PurchaseMaterialReceiptComponent implements OnInit, OnChanges {

  @Input() purchaseMatReceiptObj: PurchaseMaterialReceiptIP;
  @Input() soLockObtained:boolean;
  @Input() loadCounter: SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  disableForm: boolean = true;
  Hvr:any = {};
  public _SSOStatus = SSOStatus;

  modifyReqDate:boolean = false;
  modifyPlanDate:boolean = false;
  inputDisableMessage: string='This input is not yet enabled';

  isSAPMigoLoading: boolean = false;
  showSAPMigoModal: boolean = false;
  salesOrderFetchedFromSAPMigo: {} = {};
  sapMigoPopupRows: { label: string, value: Date }[] = [];
  sapMigoPopupTitle: string = 'MIGO Data from SAP';
  messageDetailsFromSAPMigo: string = '';
  
  constructor(public _dataService: DataService, public dialog: MatDialog, private http: HttpClient, private genService: GenService) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    if(!this.purchaseMatReceiptObj.ctApplicability){
      this.purchaseMatReceiptObj.ctApplicability = "001"; // New field - Needs to be filled for TPT+ Auto calulcation
    }
    if(!this.purchaseMatReceiptObj.breakerApplicability){
      this.purchaseMatReceiptObj.breakerApplicability = "001"; // New field - Needs to be filled for TPT+ Auto calulcation
    }
    if(!this.purchaseMatReceiptObj.meteringBoxApplicability){
      this.purchaseMatReceiptObj.meteringBoxApplicability = "001"; // New field - Needs to be filled for TPT+ Auto calulcation
    }
    this.ngOnChanges();
  }

  ngOnChanges()  {
    this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.purchaseMatReceiptObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.purchaseMatReceiptObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasMaterialReceiptEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
    this.isMigoDataPresent();
  }

  saveSso(_submitToNextSection: boolean,ssoSubmitTo:SSOStatus = SSOStatus.Not_Started) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data),
        null,
        ssoSubmitTo
      ));
    }
  }
  deleteSSo(_deleteSO:boolean){
    if(this.updateSubSalesOrder){
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }

  }

  plannedDateChangeHandler(_plndDateHeader:string, _plndTokenKeyName:string,_plndDate:Date,_plndDateChanged:Date):void{
    let _plndDateChangeObj:ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)", 
                                                  _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.purchaseMatReceiptObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.purchaseMatReceiptObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.purchaseMatReceiptObj[_plndTokenKeyName] = 
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.purchaseMatReceiptObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }

  actualDateChangeHandler(_actDateHeader:string,_actDate:Date,_actDateChanged:Date,_actTokenKeyName:string,_plndDateHeader:string,_plndDate:Date,):void{
    let _actDateChangeObj:ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader, 
                                                              _actDateChanged, this.purchaseMatReceiptObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate:Date = this.purchaseMatReceiptObj[_actTokenKeyName].actualDate;
    this.purchaseMatReceiptObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.purchaseMatReceiptObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;
        var changedDate: Date = null;
        if(_actDateChangeObj.actualDate != null){
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.purchaseMatReceiptObj[_actTokenKeyName] = 
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments,this._dataService.userId);
      }
      else {
        this.purchaseMatReceiptObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }

closeSAPMigoModal() {
    this.showSAPMigoModal = false;
  }
  onSAPSoInputMigo(event: any) {
    this.purchaseMatReceiptObj.ctptPoNo = event.target.value.replace(/[^0-9]/g, '');
  }
  onSAPRelayPoInput(event: any) {
    this.purchaseMatReceiptObj.relayPoNo = event.target.value.replace(/[^0-9]/g, '');
  }
  onSAPBreakerPoInput(event: any) {
    this.purchaseMatReceiptObj.breakerPoNo = event.target.value.replace(/[^0-9]/g, '');
  }
  onSAPSaPoInput(event: any) {
    this.purchaseMatReceiptObj.saPoNo = event.target.value.replace(/[^0-9]/g, '');
  }
  onSAPMeteringBoxPoInput(event: any) {
    this.purchaseMatReceiptObj.meteringBoxPoNo = event.target.value.replace(/[^0-9]/g, '');
  }

  private updateSAPMigoPopupData(firstDateRaw: string, lastDateRaw: string, subCategory: string): void {
    const popupCategory = subCategory === 'CTPT' ? 'CT/PT' : subCategory;
    this.sapMigoPopupTitle = 'MIGO Data from SAP - ' + popupCategory;

    const firstDate = firstDateRaw ? new Date(this.genService.parseDateFromString(firstDateRaw)) : null;
    const lastDate = lastDateRaw ? new Date(this.genService.parseDateFromString(lastDateRaw)) : null;

    this.salesOrderFetchedFromSAPMigo = {
      firstDate: firstDate,
      lastDate: lastDate
    };

    this.sapMigoPopupRows = [];
    if (subCategory === 'CTPT') {
      if (firstDate) {
        this.sapMigoPopupRows.push({ label: 'CT First Date', value: firstDate });
      }
      if (lastDate) {
        this.sapMigoPopupRows.push({ label: 'CT Last Date', value: lastDate });
      }
      return;
    }

    if (firstDate) {
      this.sapMigoPopupRows.push({ label: subCategory + ' Receipt Date', value: firstDate });
    }
  }

  private resetSAPMigoPopupData(): void {
    this.salesOrderFetchedFromSAPMigo = {};
    this.sapMigoPopupRows = [];
    this.sapMigoPopupTitle = 'MIGO Data from SAP';
  }

  isMigoDataPresent(): boolean {
    return (

      (this.purchaseMatReceiptObj.isctApplicability ? !!this.purchaseMatReceiptObj.ctPTActualReceiptFirstDate : false) ||
      (this.purchaseMatReceiptObj.isctApplicability ? !!this.purchaseMatReceiptObj.ctPTActualReceiptToken?.actualDate : false) 
    );
  }

  fetchMigoDetails() {
     this.isSAPMigoLoading = true;
    try {
    const msg = {
      "PO": this.purchaseMatReceiptObj.ctptPoNo,
      "SO": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
      "Track_No": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo.substring(3,10) + "-" + this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId
    };
    const body = {
      "soNo": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
      "subSONo": this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId,
      "userEmail": this._dataService.userId,
      "data": msg,
      "subCategory": "CTPT" // Added sub-category to identify CTPT specific fetch in backend
    };
    this.http.post('/fetchmigo_sap', body).subscribe(
      (res: any) => {

        this.isSAPMigoLoading = false;

        if(res.status === "OK"){
          let resultData = res.data.data;

          if (resultData.ctPTFirstDate == "" || resultData.ctPTLastDate == "") {
            this.resetSAPMigoPopupData();
            this.messageDetailsFromSAPMigo = 'No SAP data available.';
            this.showSAPMigoModal = true;
            console.error('No SAP data found:', res);

            console.log('Migo details fetched from SAP:', res.data);
          }
          else {
          if(this.purchaseMatReceiptObj.isctApplicability){
            if(resultData.ctPTFirstDate){
              this.purchaseMatReceiptObj.ctPTActualReceiptFirstDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
            }
            if(resultData.ctPTLastDate){
            this.purchaseMatReceiptObj.ctPTActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTLastDate));
            this.purchaseMatReceiptObj.ctPTActualReceiptToken.addNotes = "Fetched from SAP Migo data - Last receipt date";
            this.purchaseMatReceiptObj.ctPTActualReceiptToken.userOveridden = this._dataService.userId;
            this.purchaseMatReceiptObj.ctPTActualReceiptToken.isOveridden = true;
            }
          }
          // if(resultData.ctPTFirstDate){
          // this.purchaseMatReceiptObj.relayActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
          // this.purchaseMatReceiptObj.relayActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
          // this.purchaseMatReceiptObj.relayActualReceiptToken.userOveridden = this._dataService.userId;
          // this.purchaseMatReceiptObj.relayActualReceiptToken.isOveridden = true;

          // if(this.purchaseMatReceiptObj.isbreakerApplicability){
          // this.purchaseMatReceiptObj.breakerActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
          // this.purchaseMatReceiptObj.breakerActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
          // this.purchaseMatReceiptObj.breakerActualReceiptToken.userOveridden = this._dataService.userId;
          // this.purchaseMatReceiptObj.breakerActualReceiptToken.isOveridden = true;
          // }

          // this.purchaseMatReceiptObj.saActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
          // this.purchaseMatReceiptObj.saActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
          // this.purchaseMatReceiptObj.saActualReceiptToken.userOveridden = this._dataService.userId;
          // this.purchaseMatReceiptObj.saActualReceiptToken.isOveridden = true;

          // if(this.purchaseMatReceiptObj.ismeteringBoxApplicability){
          //   this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
          //   this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
          //   this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.userOveridden = this._dataService.userId;
          //   this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.isOveridden = true;
          // }
          this.updateSAPMigoPopupData(resultData.ctPTFirstDate, resultData.ctPTLastDate, body.subCategory);
        
          console.log('Processed Migo details:', this.salesOrderFetchedFromSAPMigo);

          this.messageDetailsFromSAPMigo = res.message || 'SAP data fetched successfully.';
            this.showSAPMigoModal = true;
            // }
          }
          } else {
            this.resetSAPMigoPopupData();
            this.messageDetailsFromSAPMigo = res.message || 'No SAP data available.';
            this.showSAPMigoModal = true;
            console.error('No SAP data found:', res);
          }
        console.log('Direct fetchmigo_sap API response:', res);
        
      },
      (err) => {
          this.isSAPMigoLoading = false;
          this.resetSAPMigoPopupData();
          console.error('SAP fetch error:', err);
        });
      } catch (e) {
        this.isSAPMigoLoading = false;
        this.resetSAPMigoPopupData();
        console.error(e);
      }
    }

  fetchRelayMigoDetails() {
    this.isSAPMigoLoading = true;
    try {
      const msg = {
        "PO": this.purchaseMatReceiptObj.relayPoNo,
        "SO": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "Track_No": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo.substring(3, 10) + "-" + this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId
      };
      const body = {
        "soNo": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "subSONo": this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId,
        "userEmail": this._dataService.userId,
        "data": msg,
        "subCategory": "Relay" // Added sub-category to identify relay specific fetch in backend
      };
      this.http.post('/fetchmigo_sap', body).subscribe(
        (res: any) => {
          this.isSAPMigoLoading = false;
          if (res.status === "OK") {
            let resultData = res.data.data;
            if (resultData.ctPTFirstDate == "" || resultData.ctPTLastDate == "") {
              this.resetSAPMigoPopupData();
              this.messageDetailsFromSAPMigo = 'No SAP data available.';
              this.showSAPMigoModal = true;
            } else {
              if (resultData.ctPTFirstDate) {
                this.purchaseMatReceiptObj.relayActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
                this.purchaseMatReceiptObj.relayActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
                this.purchaseMatReceiptObj.relayActualReceiptToken.userOveridden = this._dataService.userId;
                this.purchaseMatReceiptObj.relayActualReceiptToken.isOveridden = true;
                this.updateSAPMigoPopupData(resultData.ctPTFirstDate, resultData.ctPTLastDate, body.subCategory);
              }
              this.messageDetailsFromSAPMigo = res.message || 'SAP data fetched successfully.';
              this.showSAPMigoModal = true;
            }
          } else {
            this.resetSAPMigoPopupData();
            this.messageDetailsFromSAPMigo = res.message || 'No SAP data available.';
            this.showSAPMigoModal = true;
          }
        },
        (err) => {
          this.isSAPMigoLoading = false;
          this.resetSAPMigoPopupData();
          console.error('SAP fetch error:', err);
        });
    } catch (e) {
      this.isSAPMigoLoading = false;
      this.resetSAPMigoPopupData();
      console.error(e);
    }
  }

  fetchBreakerMigoDetails() {
    this.isSAPMigoLoading = true;
    try {
      const msg = {
        "PO": this.purchaseMatReceiptObj.breakerPoNo,
        "SO": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "Track_No": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo.substring(3, 10) + "-" + this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId
      };
      const body = {
        "soNo": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "subSONo": this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId,
        "userEmail": this._dataService.userId,
        "data": msg,
        "subCategory": "Breaker" // Added sub-category to identify breaker specific fetch in backend
      };
      this.http.post('/fetchmigo_sap', body).subscribe(
        (res: any) => {
          this.isSAPMigoLoading = false;
          if (res.status === "OK") {
            let resultData = res.data.data;
            if (resultData.ctPTFirstDate == "" || resultData.ctPTLastDate == "") {
              this.resetSAPMigoPopupData();
              this.messageDetailsFromSAPMigo = 'No SAP data available.';
              this.showSAPMigoModal = true;
            } else {
              if (resultData.ctPTFirstDate && this.purchaseMatReceiptObj.isbreakerApplicability) {
                this.purchaseMatReceiptObj.breakerActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
                this.purchaseMatReceiptObj.breakerActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
                this.purchaseMatReceiptObj.breakerActualReceiptToken.userOveridden = this._dataService.userId;
                this.purchaseMatReceiptObj.breakerActualReceiptToken.isOveridden = true;
                this.updateSAPMigoPopupData(resultData.ctPTFirstDate, resultData.ctPTLastDate, body.subCategory);
              }
              this.messageDetailsFromSAPMigo = res.message || 'SAP data fetched successfully.';
              this.showSAPMigoModal = true;
            }
          } else {
            this.resetSAPMigoPopupData();
            this.messageDetailsFromSAPMigo = res.message || 'No SAP data available.';
            this.showSAPMigoModal = true;
          }
        },
        (err) => {
          this.isSAPMigoLoading = false;
          this.resetSAPMigoPopupData();
          console.error('SAP fetch error:', err);
        });
    } catch (e) {
      this.isSAPMigoLoading = false;
      this.resetSAPMigoPopupData();
      console.error(e);
    }
  }

  fetchSaMigoDetails() {
    this.isSAPMigoLoading = true;
    try {
      const msg = {
        "PO": this.purchaseMatReceiptObj.saPoNo,
        "SO": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "Track_No": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo.substring(3, 10) + "-" + this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId
      };
      const body = {
        "soNo": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "subSONo": this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId,
        "userEmail": this._dataService.userId,
        "data": msg,
        "subCategory": "SA" // Added sub-category to identify SA specific fetch in backend
      };
      this.http.post('/fetchmigo_sap', body).subscribe(
        (res: any) => {
          this.isSAPMigoLoading = false;
          if (res.status === "OK") {
            let resultData = res.data.data;
            if (resultData.ctPTFirstDate == "" || resultData.ctPTLastDate == "") {
              this.resetSAPMigoPopupData();
              this.messageDetailsFromSAPMigo = 'No SAP data available.';
              this.showSAPMigoModal = true;
            } else {
              if (resultData.ctPTFirstDate) {
                this.purchaseMatReceiptObj.saActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
                this.purchaseMatReceiptObj.saActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
                this.purchaseMatReceiptObj.saActualReceiptToken.userOveridden = this._dataService.userId;
                this.purchaseMatReceiptObj.saActualReceiptToken.isOveridden = true;
                this.updateSAPMigoPopupData(resultData.ctPTFirstDate, resultData.ctPTLastDate, body.subCategory);
              }
              this.messageDetailsFromSAPMigo = res.message || 'SAP data fetched successfully.';
              this.showSAPMigoModal = true;
            }
          } else {
            this.resetSAPMigoPopupData();
            this.messageDetailsFromSAPMigo = res.message || 'No SAP data available.';
            this.showSAPMigoModal = true;
          }
        },
        (err) => {
          this.isSAPMigoLoading = false;
          this.resetSAPMigoPopupData();
          console.error('SAP fetch error:', err);
        });
    } catch (e) {
      this.isSAPMigoLoading = false;
      this.resetSAPMigoPopupData();
      console.error(e);
    }
  }

  fetchMeteringBoxMigoDetails() {
    this.isSAPMigoLoading = true;
    try {
      const msg = {
        "PO": this.purchaseMatReceiptObj.meteringBoxPoNo,
        "SO": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "Track_No": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo.substring(3, 10) + "-" + this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId
      };
      const body = {
        "soNo": this.purchaseMatReceiptObj.parentSORef?.marketingIP?.salesOrderNo,
        "subSONo": this.purchaseMatReceiptObj.parentSubSORef?.subOrderNoId,
        "userEmail": this._dataService.userId,
        "data": msg,
        "subCategory": "Metering Box" // Added sub-category to identify metering box specific fetch in backend
      };
      this.http.post('/fetchmigo_sap', body).subscribe(
        (res: any) => {
          this.isSAPMigoLoading = false;
          if (res.status === "OK") {
            let resultData = res.data.data;
            if (resultData.ctPTFirstDate == "" || resultData.ctPTLastDate == "") {
              this.resetSAPMigoPopupData();
              this.messageDetailsFromSAPMigo = 'No SAP data available.';
              this.showSAPMigoModal = true;
            } else {
              if (resultData.ctPTFirstDate && this.purchaseMatReceiptObj.ismeteringBoxApplicability) {
                this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.actualDate = new Date(this.genService.parseDateFromString(resultData.ctPTFirstDate));
                this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.addNotes = "Fetched from SAP Migo data - First receipt date";
                this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.userOveridden = this._dataService.userId;
                this.purchaseMatReceiptObj.meteringBoxActualReceiptToken.isOveridden = true;
                this.updateSAPMigoPopupData(resultData.ctPTFirstDate, resultData.ctPTLastDate, body.subCategory);
              }
              this.messageDetailsFromSAPMigo = res.message || 'SAP data fetched successfully.';
              this.showSAPMigoModal = true;
            }
          } else {
            this.resetSAPMigoPopupData();
            this.messageDetailsFromSAPMigo = res.message || 'No SAP data available.';
            this.showSAPMigoModal = true;
          }
        },
        (err) => {
          this.isSAPMigoLoading = false;
          this.resetSAPMigoPopupData();
          console.error('SAP fetch error:', err);
        });
    } catch (e) {
      this.isSAPMigoLoading = false;
      this.resetSAPMigoPopupData();
      console.error(e);
    }
  }
}
